// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.padTop{
  padding-top: 10%;
}

.padH1 {
  padding-top: 2%;
}

.form-control{
  box-shadow: none;
}

#overlay {
  background: #ffffff;
  color: #666666;
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 5000;
  top: 0;
  left: 0;
  float: left;
  text-align: center;
  padding-top: 25%;
  opacity: .80;
}
button:focus, button:active:focus, button.active:focus {
  outline: none !important;
  outline-style: none !important;
  }

mat-form-field {
  width: 250px;
}

@media(max-width: 1000px) {
  .mobileHide {
    display: none;
  }
}
@media(min-width: 1000px) {
  .desktopHide {
    display: none;
  }
  /* input color class */
  input.mat-input-element {
    color: #666666;
  }
}


`, "",{"version":3,"sources":["webpack://./src/app/login-partner/login-partner.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,MAAM;EACN,OAAO;EACP,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B;;AAEF;EACE,YAAY;AACd;;AAEA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;EACA,sBAAsB;EACtB;IACE,cAAc;EAChB;AACF","sourcesContent":[".padTop{\n  padding-top: 10%;\n}\n\n.padH1 {\n  padding-top: 2%;\n}\n\n.form-control{\n  box-shadow: none;\n}\n\n#overlay {\n  background: #ffffff;\n  color: #666666;\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  z-index: 5000;\n  top: 0;\n  left: 0;\n  float: left;\n  text-align: center;\n  padding-top: 25%;\n  opacity: .80;\n}\nbutton:focus, button:active:focus, button.active:focus {\n  outline: none !important;\n  outline-style: none !important;\n  }\n\nmat-form-field {\n  width: 250px;\n}\n\n@media(max-width: 1000px) {\n  .mobileHide {\n    display: none;\n  }\n}\n@media(min-width: 1000px) {\n  .desktopHide {\n    display: none;\n  }\n  /* input color class */\n  input.mat-input-element {\n    color: #666666;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
